import * as api from "../Api";
import {searchCustomerOrderNumberRequestSuccess} from "./CustomerOrderNumberViewActions";

export const searchCustomerOrderNumber = (type, searchKey) => {
    return (dispatch) => {
        api.searchCustomerOrderNumber(type,searchKey)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(searchCustomerOrderNumberRequestSuccess(resp.data.data))
                } else {
                    dispatch(searchCustomerOrderNumberRequestSuccess(resp.data.message))
                }
            }).catch(error => {
            dispatch(searchCustomerOrderNumberRequestSuccess(error.message))
        })
    }
}
